export default "__VITE_ASSET__5b3044e0__"